export default function PolicyLayout({ title, updated, children, testId }) {
  return (
    <div className="max-w-3xl mx-auto px-6 lg:px-10 py-16 lg:py-24" data-testid={testId}>
      <div className="mb-10">
        <div className="text-xs uppercase tracking-[0.28em] text-terracotta font-bold mb-3">Pawsomeland Foundation</div>
        <h1 className="font-serif text-4xl lg:text-5xl font-light text-forest leading-tight mb-3">{title}</h1>
        <div className="text-sm text-ink/60">Last updated: {updated}</div>
      </div>
      <article className="prose-policy space-y-4 text-ink/80 leading-relaxed">
        {children}
      </article>
    </div>
  );
}
